import Header from "./sub-components/Header";
import '../../../src/styles/notification.css';
import { db } from './firebase/firebase';
import { doc, setDoc, getDocs, collection, query, addDoc, where, updateDoc } from "firebase/firestore";
import { Link } from 'react-router-dom'
import { useEffect, useState } from "react";
import { de_encrypt } from "../../encryption";
import BaseNav from "./sub-components/BaseNav";
const Notification = () => {
    const [notifications,setNotifications]=useState(null);
    const all_not=[];
    const user_id=de_encrypt(localStorage.getItem('user-key'));
    const __convert_date=(seconds)=>{
        return new Date(seconds).toDateString()
    }
    useEffect(()=>{
      if(notifications==null){
        ( async ()=>{
            const q = query(collection(db, "notifications"), where("to", "==", user_id));
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach((doc) => {
                        all_not.push(doc.data())
             });
             setNotifications(all_not.sort((a,b)=>{return b.time - a.time}))
        })()
      }
    
      
   },[notifications])
   if(notifications){
    return ( 
        <div className="dashboard notification-container utility">
             <Header />  
             <BaseNav active={"Notifications"}/>
           <div className="notifications">
                        {
                         notifications.map(notification=>(
                            <div className="notification new">
                                <span className={`tag ${notification.type}`}>{notification.type}</span>
                                <strong>{notification.subject}</strong>
                                <p>{notification.body}</p>
                                <span className="time">{__convert_date(notification.time)}</span>
                            </div>
                         ))
                        }
            </div> 
            
        </div>
     );
   }else{
    return (
        <div className="loader-container">
            <div className="loader-header bg-w">
                <div className="container">
                    <div className="loader-header-top loader-element"></div>
                    <div className="loader-header-bottom loader-element"></div>
                </div>
            </div>
            <div className="loader-main bg-ws">
               <div className="loader-notifications loader-element bg-w">
                  <div className="loader-notification">
                      <div className="loader-notification-tag loader-element"></div>
                      <div className="loader-notification-header loader-element"></div>
                      <div className="loader-notification-body loader-element"></div>
                      <div className="loader-notification-date loader-element"></div>
                  </div>
                  <div className="loader-notification">
                      <div className="loader-notification-tag loader-element"></div>
                      <div className="loader-notification-header loader-element"></div>
                      <div className="loader-notification-body loader-element"></div>
                      <div className="loader-notification-date loader-element"></div>
                  </div>
                  <div className="loader-notification">
                      <div className="loader-notification-tag loader-element"></div>
                      <div className="loader-notification-header loader-element"></div>
                      <div className="loader-notification-body loader-element"></div>
                      <div className="loader-notification-date loader-element"></div>
                  </div>
                  <div className="loader-notification">
                      <div className="loader-notification-tag loader-element"></div>
                      <div className="loader-notification-header loader-element"></div>
                      <div className="loader-notification-body loader-element"></div>
                      <div className="loader-notification-date loader-element"></div>
                  </div>
               </div>
            </div>
        </div>
    )

   }
}
 
export default Notification;
